export const gameApi = {
  playGame: (params) => ({ url: 'v2/:clientId/game/play', method: 'get', params }),
  demoGame: (params) => ({ url: 'v2/:clientId/game/demo', method: 'get', params, isPublic: true }),
  logoutGame: ({ uid_site, provider_id }) => ({ url: 'v2/:clientId/game/logout', method: 'get', params: { uid_site, provider_id } }),

  getGameTags: ({ q, lang, limit = 20 }) => ({
    url: 'v2/:clientId/game/search',
    method: 'get',
    params: { q, lang, limit },
    isPublic: true,
  }),
  getGameSearchHome: () => ({ url: 'v2/:clientId/game/search/home', method: 'get' }),
  getGameSearchList: ({ id, index, q, click, clickDefault, providerName }) => ({
    url: 'v2/:clientId/game/search/list',
    method: 'get',
    params: { id, index, q, click, clickDefault, providerName },
    isPublic: true,
  }),
  setGameSearchTrace: ({
    traceId,
    tagId,
    tagIndex,
    gameCode,
    gameCodeIndex,
    query,
    click,
    clickDefault,
    isYouMayLike,
    isRecentlyGame,
    isRecentlySearch,
  }) => ({
    url: 'v2/:clientId/game/search/trace',
    method: 'post',
    params: {
      traceId,
      tagId,
      tagIndex,
      gameCode,
      gameCodeIndex,
      query,
      click,
      clickDefault,
      isYouMayLike,
      isRecentlyGame,
      isRecentlySearch,
    },
  }),
  gameHistory: ({ requestTimestamp, lang, provider, type, seqStatus }) => ({
    url: 'v2/:clientId/game/history',
    method: 'post',
    params: { requestTimestamp, lang, provider, type, seqStatus },
  }),
  gameHistoryDetail: ({ requestTimestamp, provider, gameId, lang, page, row }) => ({
    url: 'v2/:clientId/game/history/detail',
    method: 'post',
    params: { requestTimestamp, provider, gameId, lang, page, row },
  }),
  gameHistoryOptions: () => ({
    url: 'v2/:clientId/game/history/options',
    method: 'get',
  }),
  getListRoot: ({ timestamp, appSecret } = {}) => ({
    url: 'v2/:clientId/game/list/v3/root',
    method: 'get',
    params: { timestamp, appSecret },
    isPublic: true,
  }),
  getListCategory: ({ categoryId, timestamp, index, appSecret }) => {
    if (!categoryId) {
      throw new Error('categoryId parameter is required for getListCategory API')
    }
    return {
      url: 'v2/:clientId/game/list/v3/category',
      method: 'get',
      params: { categoryId, timestamp, index, appSecret },
      isPublic: true,
    }
  },
  getListAddition: ({ categoryId, timestamp, index, appSecret }) => {
    if (!categoryId) {
      throw new Error('categoryId parameter is required for getListAddition API')
    }
    return {
      url: 'v2/:clientId/game/list/v3/addition',
      method: 'get',
      params: { categoryId, timestamp, index, appSecret },
      isPublic: true,
    }
  },
  getListCategoryByRange: ({ categoryId, timestamp, end, appSecret }) => {
    if (!categoryId) {
      throw new Error('categoryId parameter is required for getListCategoryByRange API')
    }
    return {
      url: 'v2/:clientId/game/list/v3/category-by-range',
      method: 'get',
      params: { categoryId, timestamp, end, appSecret },
      isPublic: true,
    }
  },
  getListAdditionByRange: ({ categoryId, timestamp, end, appSecret }) => {
    if (!categoryId) {
      throw new Error('categoryId parameter is required for getListAdditionByRange API')
    }
    return {
      url: 'v2/:clientId/game/list/v3/addition-by-range',
      method: 'get',
      params: { categoryId, timestamp, end, appSecret },
      isPublic: true,
    }
  },
  getListMyFavorite: ({ timestamp } = {}) => ({
    url: 'v2/:clientId/game/list/v3/my-favorite',
    method: 'get',
    params: { timestamp },
  }),
  addListFavorite: (code) => ({ method: 'post', url: 'v2/:clientId/game/list/v3/add-my-favorite', params: { games: [code] } }),
  removeListFavorite: (code) => ({ method: 'post', url: 'v2/:clientId/game/list/v3/remove-my-favorite', params: { games: [code] } }),
  getGameReplayInfo: ({ providerId, seqNo, lang, appSecret }) => ({
    method: 'get',
    url: 'v2/:clientId/game/game-replay',
    params: { providerId, seqNo, lang, appSecret },
    isPublic: true,
  }),
  getFreeGameList: () => ({ method: 'get', url: 'v2/:clientId/activities/free-game/get-free-game-reward-list' }),
  getFreeGameReward: ({ activityNo, receiveNo }) => ({
    method: 'post',
    url: 'v2/:clientId/activities/free-game/get-free-game-reward',
    params: { activityNo, receiveNo },
  }),
  getV3GameInfo: ({ appSecret, gameCodes }) => ({
    method: 'post',
    url: 'v2/:clientId/game/list/v3/game-info',
    params: { appSecret, gameCodes },
    isPublic: true,
  }),
  getProvableResult: ({ providerId, seqNo, lang, uidSite, appSecret }) => ({
    method: 'get',
    url: 'v2/:clientId/game/provable-result',
    params: { providerId, seqNo, lang, uidSite, appSecret },
    isPublic: true,
  }),
  getBetslip: ({ providerId, seqNo, lang, appSecret }) => ({
    method: 'get',
    url: 'v2/:clientId/game/betslip',
    params: { providerId, seqNo, lang, appSecret },
    isPublic: true,
  }),
}
